import { ImprintMethodModel, ProductSpecModel } from '../model'
import { useApp } from '../store/modules/app'
import { type MiniSpecGroup, type PriceInfo } from '../types'
import { getImprintMethodByPriceList } from './use-imprint'
import { getSpecListByPriceList } from './use-price'
import { getImprintMinQty, getMinQty, getTotalQty } from './use-quantity'
import { useWindow } from './use-window'

/**
 * 只要method 和location，其他附加属性都不需要
 */
// export type UpdateImprintMethod = Pick<
//   ImprintMethodModel,
//   'methodName' | 'locationName'
// >;

export type UpdateViewOptions = {
  isBlank: boolean
  selectedProductSpecList: ProductSpecModel[]
  selectedSpecList: MiniSpecGroup[]
  selectedAddonList: MiniSpecGroup[]
  selectedImprintMethodList: ImprintMethodModel[]
  priceList: PriceInfo[]
}
// 把所有选项变成可选的

// 更新view信息
export const useUpdateView = (options: UpdateViewOptions) => {
  const { productSpecList, specList, addonList, locationGroupList } = useWindow()
  const appState = useApp();


  const totalQty = getTotalQty(options.selectedProductSpecList)

  // 先把所有的都恢复初始状态
  const specLimitation = getSpecListByPriceList(options.priceList, productSpecList, specList, addonList)

  for (const key in specLimitation) {
    const element = specLimitation[key]

    const ps = productSpecList.find((f) => f.name === key)
    if (ps) {

      ps.values.forEach((val) => {
        if (element.includes(val.value)) {
          val.enabled = true
        } else {
          val.enabled = false
        }
      })
    }
    const sp = specList.find((f) => f.name === key)
    if (sp) {
      sp.values.forEach((val) => {
        if (element.includes(val.value)) {
          val.enabled = true
        } else {
          val.enabled = false
        }
      })
    }

    const addonValues = addonList.find((f) => f.name === key)

    if (addonValues) {
      addonValues.values.forEach((val) => {
        if (element.includes(val.value)) {
          val.enabled = true
        } else {
          val.enabled = false
        }
      })
    }
  }

  // 如果不是blank，那就要重新计算imprint method的限制
  const imprintLimitation = getImprintMethodByPriceList(options.priceList)
  locationGroupList.forEach((locationGroup) => {
    locationGroup.Selected = false
    const validMethods = locationGroup.Methods.filter((k) => imprintLimitation.some((m) => m.Method === k.Method && m.Location === k.Location))

    if (validMethods.length > 0) {
      for (const method of locationGroup.Methods) {
        if (validMethods.includes(method)) {
          if (options.selectedProductSpecList && totalQty > 0) {
            const minQty = getImprintMinQty([method])
            method.Enabled = minQty === 0 || minQty <= totalQty
          } else {
            method.Enabled = true
          }
        } else {
          method.Enabled = false
        }
      }
      locationGroup.Enabled = locationGroup.Methods.some((f) => f.Enabled)
    } else {
      locationGroup.Enabled = false
    }
  })
  // 先把所有Location都标记为可用
  locationGroupList.forEach((f) => {
    f.Selected = false
  })

  // 计算所选的imprint method，把location置灰
  if (options.selectedImprintMethodList.length > 0) {
    // 计算不可选的location
    // 从imprintLimitation 反向推算

    options.selectedImprintMethodList.forEach((f) => {
      const fi = locationGroupList.find((k) => k.Name === f.decorationMethod.Location)
      if (fi) {
        fi.Selected = true
      }
    })
  }

  // 更新最小数量  

}
